// icon:exchange | Unicons https://iconscout.com/unicons | Iconscout
import * as React from "react";

function ChangeIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="5em"
      width="5em"
      {...props}
    >
      <path d="M18 10a1 1 0 00-1-1H5.41l2.3-2.29a1 1 0 00-1.42-1.42l-4 4a1 1 0 00-.21 1.09A1 1 0 003 11h14a1 1 0 001-1zm3.92 3.62A1 1 0 0021 13H7a1 1 0 000 2h11.59l-2.3 2.29a1 1 0 000 1.42 1 1 0 001.42 0l4-4a1 1 0 00.21-1.09z" />
    </svg>
  );
}

export default ChangeIcon;
